export const isDevelopment = process.env.NODE_ENV === 'development';

export const isDevelopmentReact = process.env.REACT_APP_STAGE === 'development';

export const logDevelopmentError = (error: Error): void => {
  if (isDevelopment) console.log(error);
};
